// Slick init moved to assets/slick-init.js (loaded only on product templates).
// This file is jQuery-free and loads on every page.

document.querySelectorAll('.ctm_country .disclosure__button').forEach(button => {
  button.addEventListener('click', (e) => {
    e.stopPropagation();
    let parent = button.closest('.disclosure');

    document.querySelectorAll('.disclosure.active').forEach(el => {
      if (el !== parent) {
        el.classList.remove('active');
      }
    });

    parent.classList.toggle('active');
  });
});


document.addEventListener('click', () => {
  document.querySelectorAll('.disclosure.active').forEach(el => {
    el.classList.remove('active');
  });
});


document.querySelectorAll('.ctm_collection_btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const card = btn.closest('.card');
    if (!card) return;

    const quickAddBtns = card.querySelectorAll('.ctm_prd_price .quick-add__submit');

    quickAddBtns.forEach(qBtn => {
      qBtn.click();
    });
  });
});




document.querySelectorAll('.banner').forEach(banner => {
  banner.addEventListener('click', () => {
    const btn = banner.querySelector('.banner__buttons a');
    if (btn) {
      btn.click();
    }
  });
});


document.querySelectorAll('.ctm_card_anchor').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    let siblingAnchor = this.previousElementSibling;

    if (siblingAnchor && siblingAnchor.tagName.toLowerCase() === 'a') {
      siblingAnchor.click();
    }
  });
});




document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".ctm_collection_prd_btn").forEach(btn => {
    btn.addEventListener("click", function () {
      let productId = btn.getAttribute("data-prdid");
      if (!productId) return;

      // Cart add request
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1
        })
      })
        .then(res => res.json())
        .then(data => {
          window.location.href = '/cart';
        })
        .catch(err => console.error('Error:', err));
    });
  });
});




document.addEventListener("DOMContentLoaded", function () {
  let rawHash = window.location.hash.substring(1);

  let collectionName = rawHash ? decodeURIComponent(rawHash) : "Best Sellers";

  let collectionSlug = collectionName
    .toLowerCase()
    .replace(/[%\s#]+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

  let newUrl = `/collections/${collectionSlug}`;

  let anchor = document.querySelector(".ctm_coll_bread a");

  if (anchor) {
    anchor.href = newUrl;
    anchor.textContent = collectionName;
  }
});


// ========== Used In Top-Rated Section

if (!customElements.get('collection-cards-container')) {
  customElements.define('collection-cards-container', class extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.mobileBreakpoint = window.matchMedia('(max-width: 749px)');
      this.isCarouselEnabled = this.dataset.mobileCarousel === 'true';
      this.wrapper = this.querySelector('.swiper-wrapper');
      this.gridClasses = ['!tw-grid', 'tw-grid-cols-4', 'max-md:!tw-grid-cols-2', 'tw-gap-[20px]', 'max-md:!tw-gap-x-[14px]', 'max-md:!tw-gap-y-[18px]'];
    }

    connectedCallback() {
      if (!this.isCarouselEnabled) {
        this.applyGrid();
        return;
      }

      this.mobileBreakpoint.addEventListener('change', () => this.handleLayout());
      this.handleLayout();
    }

    handleLayout() {
      if (this.mobileBreakpoint.matches) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (this.swiperInstance || !this.isCarouselEnabled) return;

      this.wrapper.classList.remove(...this.gridClasses);
      this.wrapper.style.display = 'flex';

      this.swiperInstance = new Swiper(this, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        pagination: {
          el: this.querySelector('.swiper-pagination-mobile'),
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector('.swiper-btn-next-mobile'),
          prevEl: this.querySelector('.swiper-btn-prev-mobile'),
        },
        breakpoints: {
          480: { slidesPerView: 2.2 }
        }
      });
    }

    destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      this.applyGrid();
    }

    applyGrid() {
      this.wrapper.style.display = '';
      this.wrapper.classList.add(...this.gridClasses);
    }
  });
}
